import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {Paper, Typography} from '@material-ui/core';
import {IDepotStatistics} from 'constants/interfaces';
import {_NumberWithSpaces} from 'constants/index';

const BAR_COLORS = ['#2f7d78', '#56a36c', '#9ccfba'];

export type FunnelChartData = {
  name: string;
  value: number;
  valueFormatted: number | string;
}[];
export function AnalyticsFunnelChart(props: {data: FunnelChartData}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={props.data}
        barCategoryGap={24}
        margin={{top: 28, right: 16, bottom: 8, left: 0}}
      >
        <XAxis
          dataKey="name"
          scale="point"
          padding={{left: 80, right: 80}}
          axisLine={{stroke: '#dfe7e5'}}
          tick={{fill: '#5f6f6d', fontSize: 12, fontWeight: 600}}
          tickLine={false}
        />
        <YAxis
          width={40}
          axisLine={false}
          tickLine={false}
          padding={{top: 40}}
          hide={true}
        />
        <Tooltip
          content={<CustomTooltip />}
          cursor={{fill: 'rgba(56,124,63,0.06)'}}
        />
        <CartesianGrid
          stroke="#e7eceb"
          strokeDasharray="4 6"
          vertical={false}
        />
        <Bar dataKey="value" maxBarSize={96} radius={[8, 8, 0, 0]}>
          <LabelList
            dataKey="valueFormatted"
            position="top"
            className="analytics-chart-label"
          />
          {props.data.map((entry, index) => (
            <Cell
              key={`bar-${entry.name}`}
              fill={BAR_COLORS[index % BAR_COLORS.length]}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

function CustomTooltip(props: {
  active?: boolean;
  payload?: Array<{payload: {valueFormatted: number | string}}>;
  label?: string;
}) {
  if (!props.active || !props.payload?.length) return null;
  return (
    <Paper variant="outlined" className="recharts-custom-tooltip">
      <Typography className="title">{props.label}</Typography>
      <Typography className="value">
        {props.payload[0].payload.valueFormatted}
      </Typography>
    </Paper>
  );
}

export const toSalesCountFunnelData = (
  stats: IDepotStatistics,
): FunnelChartData => [
  {
    name: 'Quotes',
    value: stats.quotesCount,
    valueFormatted: stats.quotesCount,
  },
  {
    name: 'Orders',
    value: stats.invoicesCount,
    valueFormatted: stats.invoicesCount,
  },
  {
    name: 'Paid',
    value: stats.paidInvoicesCount,
    valueFormatted: stats.paidInvoicesCount,
  },
];

export const toSalesValueFunnelData = (
  stats: IDepotStatistics,
): FunnelChartData => [
  {
    name: 'Quotes',
    value: stats.quotesTotal,
    valueFormatted: `R ${_NumberWithSpaces(stats.quotesTotal)}`,
  },
  {
    name: 'Orders',
    value: stats.invoicesTotal,
    valueFormatted: `R ${_NumberWithSpaces(stats.invoicesTotal)}`,
  },
  {
    name: 'Paid',
    value: stats.paidInvoicesTotal,
    valueFormatted: `R ${_NumberWithSpaces(stats.paidInvoicesTotal)}`,
  },
];
